module.exports = __webpack_public_path__ + "static/img/logo_zyb.7be6f041.png";